import React, { Component } from 'react';

class ListItem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
  };

  render() {
    return (
      <tr>
        <td>{this.props.record.ID}</td>
        <td>{this.props.record.email}</td>
        <td>{this.props.record.author_name}</td>
        <td>{this.props.record.scholar_id}</td>
        <td>{this.props.record.comment}</td>
        <td>{this.props.record.reject_date}</td>
      </tr>
    )
  }
}

export default ListItem;